import React from 'react';
import { Navigate } from 'react-router-dom';

// Component for protecting routes that require authentication
const ProtectedRoute = ({ children, isAuthenticated }) => {
  if (!isAuthenticated) {
    // If not authenticated, redirect to login page
    return <Navigate to="/login" replace />;
  }

  // If authenticated, render the protected component
  return children;
};

export default ProtectedRoute; 